import { Component, ElementRef, Inject, Input, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { SafeUrl } from '@angular/platform-browser';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { data } from 'jquery';
import html2canvas from 'html2canvas';
import { HttpClient } from '@angular/common/http';
import { QrcodedetailcloseComponent } from '../qrcodedetailclose/qrcodedetailclose.component';
import { Constants } from 'src/@smartmanufacturing/common/constants';


@Component({
  selector: 'app-qrcode',
  templateUrl: './qrcode.component.html',
  styleUrls: ['./qrcode.component.scss']
})
export class QRCodeComponent implements OnInit {
  qrcodedetaildataArray: any;
  @ViewChild('qrcodeContainer') qrcodeContainer!: ElementRef;
  fileName: any;
  o3Logo1: string = '../../../assets/images/O3sigma_logo_blue.png';
  o3Logo2: string = '../../assets/Content/assets/img/OPF_LOGO.png';
  toolsLogo: string = 'assets/images/Tools.png';

  QRCode: any;
  technicianList: any[];
  assignedTechnician: string = '';
  technicianImage: string = '';
  blobUrl: string = "";
  filtTechList: any[];
  isTechnician: boolean;
  techId: any;
  selectedTechnicianId: any;

  constructor(private dialog: MatDialog, private http: HttpClient,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {


  }
  qrCodeDownloadLink: any;
  ngOnInit(): void {
    this.blobUrl = Constants.BLOB_STORAGE_URL;
    this.qrcodedetaildataArray = JSON.parse(this.data?.data);
    this.fileName = this.data?.fileName
    this.technicianList = this.data?.technicianList
    this.isTechnician = this.data?.isTechnician
    this.filtTechList = this.technicianList?.slice();
    this.techId = this.data?.techId;

    if (this.techId) {
      const technicianObj = this.technicianList.find(technician => technician.AssignTechnician === this.techId);
      this.assignedTechnician = technicianObj.fullName;
      this.technicianImage = technicianObj.Picture;
    }
    if (this.technicianList && !this.techId) {
      this.selectedTechnicianId = this.technicianList.length > 0 ? this.technicianList[0].AssignTechnician : null;
      this.assignedTechnician = this.technicianList[0].fullName;
      this.technicianImage = this.technicianList[0].Picture;
    }
  }

  onChangeURL(url: SafeUrl) {
    this.qrCodeDownloadLink = url;
  }

  PrintQRCode() {
    fetch(this.qrCodeDownloadLink.changingThisBreaksApplicationSecurity)
      .then(response => response.blob())
      .then(blob => {
        const objectURL = URL.createObjectURL(blob);
        const img = document.createElement('img');
        const p = document.createElement('p');
        p.style.fontWeight = '600'
        img.src = objectURL;
        p.textContent = this.qrcodedetaildataArray?.woId;
        let QrCodeDiv = document.createElement('div');
        QrCodeDiv.style.textAlign = 'center';
        QrCodeDiv.appendChild(img);
        QrCodeDiv.appendChild(p);
        this.dialog.closeAll();
        const WindowPrt: any = window.open('', '_blank');
        const style = WindowPrt.document.createElement('style');
        style.innerHTML = `@page {
          size: auto;
          margin: 0mm;
        }`;
        WindowPrt.document.head.appendChild(style);
        const body = WindowPrt.document.body; // Access the body of the newly opened window
        body.appendChild(QrCodeDiv);
        body.style.display = 'flex'
        body.style.justifyContent = 'center'
        body.style.alignItems = 'center';
        WindowPrt.document.title = 'Batch';
        setTimeout(() => {
          WindowPrt.document.close();
          WindowPrt.focus();
          WindowPrt.print();
          WindowPrt.close();
        }, 1000);
      })
      .catch(error => {
        console.error('Error fetching and converting QR code:', error);
      });
  }

  onChangeTechnician(event: any): void {
    console.log(event.value, 'tech value')
    const technicianObj = this.technicianList.find(technician => technician.AssignTechnician === event.value);
    if (technicianObj && !this.techId) {
      this.assignedTechnician = technicianObj.fullName;
      this.technicianImage = technicianObj.Picture;
    }
  }

  getColumnNames(row: any): string[] {
    return Object.keys(row);
  }

  openDialog() {
    this.dialog.open(QrcodedetailcloseComponent, {
      panelClass: 'custom-dialog-container',
      width: '40%',
      height: '40%',
      disableClose: true,
      data: this.qrcodedetaildataArray,
    });
  }


  // printOutReport(): void {
  //
  //     this.dialog.closeAll();
  //     this.printReport();
  //     //this.QrCode();
  // }

  // generateTableHtml() {
  //   let tableHtml;
  //   let colLength = 0;
  //   const data = [this.qrcodedetaildataArray];
  //   tableHtml = `<h1 class="heading-text" style="font-size: x-large;display:none">QR Code Details</h1>`
  //   tableHtml += '<table>';
  //   tableHtml += '<tbody>';
  //   for (const item of data) {
  //     const columnNames = Object.keys(item);
  //     tableHtml += '<tr>';
  //     for (const columnName of columnNames) {
  //       const columnValue = item[columnName];
  //       tableHtml += `<td>${columnName}`;
  //       tableHtml += ' : ';
  //       tableHtml += `${columnValue}</td>`;
  //       colLength++;
  //       if (colLength % 4 === 0) {
  //         tableHtml += '</tr>';
  //         tableHtml += '<tr>';
  //       }
  //     }
  //     tableHtml += '</tr>';
  //     const text = this.modifiedHtml(tableHtml);
  //     tableHtml = text;
  //   }
  //   tableHtml += '</tbody></table>';
  //   console.log('Dynamic Table Data', tableHtml);
  //   return tableHtml;
  // }




  generateTableHtml() {
    let tableHtml;
    const data = this.qrcodedetaildataArray;
    const imagePath1 = '../../../assets/images/O3sigma_logo_blue.png';
    const imagePath2 = '../../assets/Content/assets/img/OPF_LOGO.png';
    tableHtml = `
      <div class="logoBar">
        <img style="padding: 10px;width: 6rem;" src="${imagePath1}" alt="Not Available">
        <h2>Maintenance</h2>
        <img style="padding: 10px;" src="${imagePath2}" alt="Not Available">
      </div>

      <div style="border-bottom: 1px solid black;">
        <table style="border-collapse: collapse; width: 100%;">
          <tr>
            <td style="border: none; padding: 10px; ">WO Id</td>
            <td style="border: none; padding: 10px;">${data.woId}</td>
            <td style="border: none; padding: 10px;">WO Type</td>
            <td style="border: none; padding: 10px;">${data.woType}</td>
          </tr>
          <tr>
            <td style="border: none; padding: 10px;">WO Details</td>
            <td colspan="3" style="border: none; padding: 10px;width: 75%;
            word-break: break-all;">${data.woDetails}</td>
          </tr>
          <tr>
            <td style="border: none; padding: 10px; ">Created At</td>
            <td style="border: none; padding: 10px; ">${data.createdAt}</td>
            <td style="border: none; padding: 10px;">Created By</td>
            <td style="border: none; padding: 10px;">${data.createdBy}</td>
          </tr>
        </table>
      </div>

      <div style="border-bottom: 1px solid black; height: 37px"></div>

      <div style="border-bottom: 1px solid black;">
        <table style="border-collapse: collapse; width: 100%;">
          <tr>
            <td style="border: none; padding: 10px;">Line</td>
            <td style="border: none; padding: 10px;">${data.line}</td>
            <td style="border: none; padding: 10px;">Machine</td>
            <td style="border: none; padding: 10px;">${data.machine}</td>
          </tr>
          <tr>
            <td style="border: none; padding: 10px;">Failure Mode</td>
            <td style="border: none; padding: 10px;">${data.failureMode}</td>
            <td style="border: none; padding: 10px;">Spare Parts</td>
            <td style="border: none; padding: 10px;">${data.sparePart}</td>
          </tr>
          <tr>
            <td style="border: none; padding: 10px;">Assmenbly</td>
            <td style="border: none; padding: 10px;">${data.assembly}</td>
            <td style="border: none; padding: 10px;">Sub Assembly</td>
            <td style="border: none; padding: 10px;">${data.subAssembly}</td>
          </tr>
          <tr>
            <td style="border: none; padding: 10px;">Components</td>
            <td style="border: none; padding: 10px;">${data.component}</td>
          </tr>
        </table>
      </div>

      <div style="border-bottom: 1px solid black; height: 37px"></div>

      <div style="border-bottom: 1px solid black;">
        <table style="border-collapse: collapse; width: 100%;">
          <tr>
            <td style="border: none; padding: 10px;">Assign Technician Time</td>
            <td style="border: none; padding: 10px;">${data.assignedTechnicianTime}</td>
            <td style="border: none; padding: 10px;">Assign Technician</td>
            <td style="border: none; padding: 10px;">${this.assignedTechnician}</td>
          </tr>
        </table>
      </div>
    `;

    return tableHtml;
  }


  getStyle(): any {
    let style = `<style>


.logoBar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid black;
}

h1 {
  margin: 0; /* Remove default margin for h1 */
}

img {
  height: 50px;
  margin: 5px;
}

.qrandTechnician {
  display: flex;
  width: 100%;
  height: 100%;
}

.column1 {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 60%;
}

.column2 {
  display: flex;
  align-items: center;
  flex-direction: column;
  width: 40%;
}

.center-content {
  text-align: center; /* Center content horizontally within container */
}

.center-text {
  margin-bottom: 0px;
  font-weight: 500;
  font-size: 21px;
}

.image {
  margin-bottom: 10px; /* Adjust the spacing between images if needed */
}

    .heading-text{
      font-weight:bold;font-size:13px;text-align:center;
    }
    .qrCode{
      display: flex;
      justify-content:center;
    }
    table {
      border-collapse: collapse;
      margin: auto;
      margin-bottom: 5px;
      font-size: 8px;
    }

    td,
    thead
     {
      border: 1px solid black;
      font-family: arial;
    }
    .header-side-info {
    }
    .header-side-info-heading {
      font-size: 12px;
    }
    .header-side-info-text {
      font-size: 10px;
    }

    .header-heading {
      font-weight: bold;
      font-size: 12px;
      text-align: center;
      background-color: #e0f2fe;
      -webkit-print-color-adjust: exact;
    }
    .tr_ > td {
      font-size: 8px;
      margin:1px;
      padding: 2px 10px;
    }
    .header-cell-heading {
      font-weight: bold;
      font-size:12px;
    }

    .tb-heading {
      font-size: 11px;
      background-color: #dbeafe;
      color: white;
      font-weight: bold;
      text-align: center;
      -webkit-print-color-adjust: exact;
      padding: 2px 5px;
    }
    .tb-value {
      font-size: 10px;

      text-align: center;

    }

    .filesTable {
      border: none !important;
    }
    .emptyDiv{
      display: none;
    }

    .imgTD img{
      width:500px !important;
      object-fit: cover;

    }
    .qrCode{
      padding-top: 20px;
    }
    @media print {

      .emptyDiv{
        display: block;
        height: 10px;
        page-break-before: always;
      }
      .filesTable td:nth-child(1){
        padding-right: 10px;
      }
      .filesTable {
        border: none !important;
      }
      table {
        border-collapse: collapse;
      }

            .itemGroupContainer {background: #f1f5f9}
            @page {
              margin-top: 0;
              margin-bottom: 0;
          }

      td,
      thead
       {
        border: 1px solid black;
        font-family: arial;
      }
      .header-side-info {
      }
      .header-side-info-heading {
        font-size: 12px;
      }
      .header-side-info-text {
        font-size: 10px;
      }
      .header-heading {
        font-weight: bold;
        font-size: 12px;
        text-align: center;
        background-color: #e0f2fe;
        -webkit-print-color-adjust: exact;
      }
      .tr_ > td {
        font-size: 12px;
        padding: 2px 10px;
      }
      .header-cell-heading {
        font-weight: bold;
      }

      .tb-heading {
        font-size: 11px;
        background-color: #e0f2fe;
        font-weight: bold;
        text-align: center;
        -webkit-print-color-adjust: exact;
        padding: 2px 5px;
      }
      .tb-value{
        font-size: 11px;
        padding: 2px 5px;
        text-align: center;
        :last-child{
          padding: 10px 5px;
        }
      }
    }
    </style>
    `;

    return style
  }

  QrCode(): any {
    fetch(this.qrCodeDownloadLink.changingThisBreaksApplicationSecurity)
      .then(response => response.blob())
      .then(blob => {
        const objectURL = URL.createObjectURL(blob);
        const img = document.createElement('img');
        img.src = objectURL;
        // Set the width and height for the barcode image
        img.style.width = '214px'; // adjust this size as needed
        img.style.height = '221px'; // adjust this size as needed
        // let tableHtml = `<div class="qrCode">`;

        let tableHtmlparent = document.createElement('div');
        let tableHtml = document.createElement('div');
        tableHtml.classList.add('qrCode')
        const priorityValue = document.createElement('h1');
        priorityValue.style.color = this.qrcodedetaildataArray.priorityColor;
        priorityValue.style.marginTop = '10px';
        priorityValue.style.fontSize = '41px';
        priorityValue.textContent = this.qrcodedetaildataArray.priority;

        let QrCodeDiv = document.createElement('div');
        QrCodeDiv.style.textAlign = 'center';  // Center the content horizontally
        QrCodeDiv.appendChild(priorityValue);
        QrCodeDiv.appendChild(img);

        const dynamicColumn2 = document.createElement('div');
        dynamicColumn2.classList.add('column2');
        dynamicColumn2.classList.add('center-content');

        const img1 = document.createElement('img');
        img1.alt = 'Not Available';
        img1.className = 'image';
        img1.style.height = '122px';
        img1.style.width = '134px';
        img1.src = this.technicianImage ? this.blobUrl + this.technicianImage : '../../assets/images/no-image.png';

        const img2 = document.createElement('img');
        img2.alt = 'Not Available';
        img2.className = 'image';
        img2.style.height = '122px';
        img2.style.width = '134px';
        img2.src = '../../assets/images/Tools.png';

        dynamicColumn2.appendChild(img1);
        dynamicColumn2.appendChild(img2);
        tableHtmlparent.appendChild(tableHtml)
        tableHtml.appendChild(QrCodeDiv)

        tableHtml.appendChild(dynamicColumn2);
        // tableHtml += QrCodeDiv.outerHTML;
        // tableHtml += '</div>';

        this.dialog.closeAll();
        const WindowPrt: any = window.open('', '_blank');
        let reportData;
        reportData = document.getElementById('reportContainer');

        const printStyles = `
          <style>
            body {
              width: 99mm;
              height: 210mm;
              border: 1px solid black;
            }
          </style>
        `;
        WindowPrt.document.write(printStyles);

        WindowPrt.document.write(this.getStyle());
        WindowPrt.document.write(this.generateTableHtml());
        WindowPrt.document.write(tableHtmlparent.innerHTML);
        WindowPrt.document.write(reportData.innerHTML);
        reportData
        WindowPrt.document.title = 'Material';

        setTimeout(() => {
          WindowPrt.document.close();
          WindowPrt.focus();
          WindowPrt.print();
          WindowPrt.close();
        }, 1500);
      })
      .catch(error => {
        console.error('Error fetching and converting QR code:', error);
      });
  }

  captureDiv() {

    const element = document.getElementById('divToCapture');
    if (element) {
      html2canvas(element).then((canvas) => {
        const link = document.createElement('a');
        link.download = 'div_image.png';
        link.href = canvas.toDataURL();
        link.click();
      });
    }
  }
}
